import React from "react";
import { Parallax } from "react-parallax";
import img3 from "../img/para3.jpg";
import Work from "./Work";
const Para3 = () => {
  return (
    <>
      {" "}
      <Parallax
        className={"absolute scroll-smooth min-w-screen min-h-screen"}
        bgImage={img3}
        bgImageAlt="parallax work"
        strength={1000}
      >
        <section
          aria-label="all sample work"
          className="flex  items-center h-[80rem] sm:h-[50rem] lg:h-[40rem] justify-center my-[53%] sm:my-[12%]"
        >
          <Work />
        </section>
      </Parallax>
    </>
  );
};

export default Para3;
